import { ModalAction, ModalActionType } from "../modal-action";

export interface DownloadReportParams {
    batchId?: string;
    merchantId?: undefined;
    merchantProcessorIds?: undefined;
    startDate?: undefined;
    endDate?: undefined;
    statementId?: string;
    requiresMids?: boolean;
}

export class DownloadReportModalAction extends ModalAction {
    constructor(public action: ModalActionType, public params?: DownloadReportParams) {
        super(action, params);
    }
}
